const markersParser = require('od-modules/parsers/map/accommodation_map_markers');
let bounds;
let markers;

function getPosition(dataMarker, libMap) {
    return new libMap.LatLng(dataMarker.latitude, dataMarker.longitude);
}

function getConstructorMarker(isCustomMarker, libMap) {
    return isCustomMarker
        ? require('od-modules/helpers/map/marker/marker_price')(libMap)
        : require('od-modules/helpers/map/marker/marker_standard')(libMap);
}

function buildMarker(libMap, options) {
    const MockMarker = libMap.OdigeoCustomMarkerMock;
    const Marker = MockMarker || getConstructorMarker(options.cfg.isCustomMarker, libMap);
    const markerConfig = {
        map: options.map,
        position: getPosition(options.data.coordinates, libMap),
        dataMarker: markersParser.getRenderData(options.data),
        onClickMarker: options.cfg.onClickMarker,
        isCustomMarker: Odigeo._.isObject(MockMarker) && options.cfg.isCustomMarker,
        preselectedIcon: options.cfg.preselectedMarkerIcon,
        hasTopVisibilityMarkerPreselected: options.mapConfig.absConfig.hasTopVisibilityMarkerPreselected,
        mapConfig: options.mapConfig,
    };

    return new Marker(markerConfig);
}

function getMarkerBy(validation, args) {
    return Odigeo._.find(markers, Odigeo._.partial(validation, _, args));
}

function getMarkerListBy(validation, args) {
    return Odigeo._.filter(markers, Odigeo._.partial(validation, _, args));
}

function mapMarkers(map, mapConfig, libMap) {
    return {
        createMarkers: function(cfg) {
            markers = Odigeo._.map(cfg.dataMarkers, function(data) {
                const marker = buildMarker(libMap, {data, cfg, map, mapConfig});
                bounds.extend(marker.getPosition());
                return marker;
            });
        },

        cleanMarkers: function() {
            Odigeo._.each(markers, function(mk) {
                mk.setMap(null);
            });
            markers = [];
            bounds = new libMap.LatLngBounds();
        },

        getBounds: function() {
            return bounds;
        },

        hasMarkers: function() {
            return markers.length > 0;
        },

        getMarkerList: function() {
            return markers;
        },
        updateMarkerPrice: function(accommodationDealKey, price) {
            this.getMarkerByKey(accommodationDealKey).setDataMarker('price', price);
        },

        getMarkerByPreselectedKey: Odigeo._.partial(getMarkerBy, function(marker) {
            return marker.dataMarker.preselected;
        }),

        getMarkerByKey: Odigeo._.partial(getMarkerBy, function(marker, searchKey) {
            return marker.dataMarker.accommodationDealKey === searchKey;
        }),

        getVisibleMarkerList: Odigeo._.partial(getMarkerListBy, function(marker) {
            return marker.hasElement();
        }),
    };
}

module.exports = {
    mapMarkers,
};
